import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeModule} from '../modules/home.module';

const homeRoutes: Routes = [];

export const HomeRouting: ModuleWithProviders<HomeModule> = RouterModule.forChild(homeRoutes);
